export const borderColor = { light: 'gray.200', dark: 'gray.700' };
export const bgColor = { light: '#fafafa', dark: `#282a36` };